import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const ScrollToTop = () => {
    const location = useLocation();

    useEffect(() => {
        if ("scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual";
        }

        const scrollTimer = setTimeout(() => {
            window.scrollTo({
                top: 0,
                behavior: "instant" as ScrollBehavior,
            });
        }, 50);

        return () => {
            clearTimeout(scrollTimer);
            if ("scrollRestoration" in window.history) {
                window.history.scrollRestoration = "auto";
            }
        };
    }, [location.pathname]);

    return null;
};

export default ScrollToTop;
